import React, { FC, useContext, useState } from 'react';
import {
  countDays,
  Container,
  Option,
} from '@/features/details/date-pick/quick-range-select';
import { BackBtn } from '@/features/details/date-pick/custom-picker';
import { DatePickerContext } from '@/features/details/date-pick/context';
import { VSpace } from '@/components/spacing';
import { BigButton } from '@/components/big-button';

type Props = { close: () => void };
export const VersionsSelect: FC<Props> = ({ close }) => {
  const { versions, setVersion, version, quickSelect } =
    useContext(DatePickerContext);
  const onBack = () => {
    quickSelect();
  };
  const [active, setActive] = useState(version);
  return (
    <Container>
      <BackBtn onClick={onBack} showRange={false} title="Select Version" />
      <VSpace value={1} />
      <div>
        {versions
          ?.sort((a, b) => b.version - a.version)
          ?.map((v) => (
            <Option
              key={v.version}
              onClick={() =>
                setActive(versions.find((ver) => v.version === ver.version))
              }
              isActive={active?.version === v.version}
            >
              Version {v.version}
              {` `}
              {v.isCurrent
                ? `- current (${countDays(v)} Days)`
                : `(${countDays(v)} Days)`}
            </Option>
          ))}
      </div>
      <VSpace value={3} />
      <BigButton
        onClick={() => {
          setVersion(active);
          close();
        }}
        background="blue"
        noTransform
        size="medium"
        fillWidth
      >
        Apply
      </BigButton>
      <VSpace />
    </Container>
  );
};
